import * as tslib_1 from "tslib";
import * as React from "react";
/**
 * This wrapper allows us to also render non-sancho icons. It should probably
 * remain a private component.
 */
export var IconWrapper = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, children = _a.children, other = tslib_1.__rest(_a, ["size", "color", "children"]);
    return React.cloneElement(children, tslib_1.__assign({ size: size,
        color: color, "aria-hidden": true, style: { display: "block" } }, other));
};
